var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sam-video-player"},[(_vm.loading)?_c('loader',{attrs:{"size":"sm"}}):_vm._e(),(!!_vm.error)?_c('div',{staticClass:"text-error text-center"},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }